<form [formGroup]="forgotPasswordForm" (ngSubmit)="onSubmit()">
  <mat-form-field appearance="standard">
    <mat-label>Email Address</mat-label>
    <input
      (focusout)="trimWhiteSpace()"
      matInput
      name="email"
      formControlName="email"
    />
    <mat-error *ngIf="forgotPasswordForm.get('email')?.invalid"
      >A valid email is required</mat-error
    >
  </mat-form-field>

  <div class="submit">
    <button
      mat-raised-button
      class="cancel-btn"
      type="button"
      color="accent"
      [routerLink]="['login']"
    >
      Cancel
    </button>
    <button mat-raised-button class="submit-btn" type="submit" color="accent">
      Submit
    </button>
  </div>
</form>
